import React, { useState } from 'react';
import './NewPolitica.css';
import { toast } from 'react-toastify';
import baseURL from '../../url';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTimes, faUpload, faTrash, faImage } from '@fortawesome/free-solid-svg-icons';

export default function NewPolitica({ onPoliticaCreada }) {
    const [modalOpen, setModalOpen] = useState(false);
    const [cargando, setCargando] = useState(false);

    const [titulo, setTitulo] = useState('');
    const [categoria, setCategoria] = useState('General');
    const [otraCategoria, setOtraCategoria] = useState('');
    const [descripcion, setDescripcion] = useState('');
    const [estado, setEstado] = useState('activo');
    const [orden, setOrden] = useState('0');
    const [imagen, setImagen] = useState(null);
    const [imagenPreview, setImagenPreview] = useState(null);

    const toggleModal = () => {
        setTitulo('');
        setCategoria('General');
        setOtraCategoria('');
        setDescripcion('');
        setEstado('activo');
        setOrden('0');
        setImagen(null);
        setImagenPreview(null);
        setCargando(false);
        setModalOpen(!modalOpen);
    };

    const handleImagenChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImagen(file);
            setImagenPreview(URL.createObjectURL(file));
        }
    };

    const handleQuitarImagen = () => {
        setImagen(null);
        setImagenPreview(null);
    };

    const handleSubmit = async (e) => {
        if (e) e.preventDefault();

        if (!titulo.trim()) {
            toast.error('Por favor, ingresa el título de la política.');
            return;
        }

        if (!descripcion.trim()) {
            toast.error('Por favor, ingresa el contenido o descripción de la política.');
            return;
        }

        const categoriaFinal = categoria === 'Otra' ? (otraCategoria.trim() || 'General') : categoria;

        setCargando(true);

        const formData = new FormData();
        formData.append('titulo', titulo.trim());
        formData.append('categoria', categoriaFinal);
        formData.append('descripcion', descripcion.trim());
        formData.append('estado', estado);
        formData.append('orden', parseInt(orden, 10) || 0);
        if (imagen) {
            formData.append('imagen', imagen);
        }

        try {
            const response = await fetch(`${baseURL}/politicaPost.php`, {
                method: 'POST',
                credentials: 'include',
                body: formData,
            });

            const data = await response.json();

            if (data.mensaje) {
                toast.success(data.mensaje);
                toggleModal();
                if (onPoliticaCreada) {
                    onPoliticaCreada();
                }
            } else if (data.error) {
                toast.error(data.error);
            }
        } catch (error) {
            console.error('Error al crear política:', error);
            toast.error('Error de conexión al guardar la política.');
        } finally {
            setCargando(false);
        }
    };

    return (
        <div className="NewContain">
            <button onClick={toggleModal} className="btnSave" type="button">
                <FontAwesomeIcon icon={faPlus} style={{ marginRight: '6px' }} />
                <span>Agregar Política</span>
            </button>

            {modalOpen && (
                <div className="modal">
                    <div className="modal-content modal-content-politica">
                        <div className="deFlexBack">
                            <h4>Nueva Política</h4>
                            <span className="close" onClick={toggleModal} role="button" aria-label="Cerrar">
                                <FontAwesomeIcon icon={faTimes} />
                            </span>
                        </div>

                        <form onSubmit={handleSubmit} className="politica-form-grid">
                            <fieldset>
                                <legend>Título de la Política *</legend>
                                <input
                                    type="text"
                                    placeholder="Ej: Políticas de Cancelación y Devoluciones"
                                    value={titulo}
                                    onChange={(e) => setTitulo(e.target.value)}
                                    required
                                />
                            </fieldset>

                            <div className="politica-form-row">
                                <fieldset>
                                    <legend>Categoría / Tipo</legend>
                                    <select
                                        className="politica-select"
                                        value={categoria}
                                        onChange={(e) => setCategoria(e.target.value)}
                                    >
                                        <option value="General">General</option>
                                        <option value="Términos y Condiciones">Términos y Condiciones</option>
                                        <option value="Protección de Datos">Protección de Datos</option>
                                        <option value="Protección al Menor">Protección al Menor</option>
                                        <option value="Cobro, Cancelación y Reembolso">Cobro, Cancelación y Reembolso</option>
                                        <option value="Cancelación y Reembolso">Cancelación y Reembolso</option>
                                        <option value="Envíos">Envíos</option>
                                        <option value="Reservas">Reservas</option>
                                        <option value="Cookies">Cookies</option>
                                        <option value="Otra">Otra (personalizada)...</option>
                                    </select>
                                </fieldset>

                                <fieldset>
                                    <legend>Estado</legend>
                                    <select
                                        className="politica-select"
                                        value={estado}
                                        onChange={(e) => setEstado(e.target.value)}
                                    >
                                        <option value="activo">Activo (Visible)</option>
                                        <option value="inactivo">Inactivo (Borrador)</option>
                                    </select>
                                </fieldset>

                                <fieldset>
                                    <legend>Orden</legend>
                                    <input
                                        type="number"
                                        min="0"
                                        value={orden}
                                        onChange={(e) => setOrden(e.target.value)}
                                    />
                                </fieldset>
                            </div>

                            {categoria === 'Otra' && (
                                <fieldset>
                                    <legend>Nombre de la Categoría Personalizada *</legend>
                                    <input
                                        type="text"
                                        placeholder="Ingresa la categoría..."
                                        value={otraCategoria}
                                        onChange={(e) => setOtraCategoria(e.target.value)}
                                        required
                                    />
                                </fieldset>
                            )}

                            <fieldset className="politica-fieldset-imagen">
                                <legend>
                                    <FontAwesomeIcon icon={faImage} style={{ marginRight: '6px' }} />
                                    Imagen / Afiche Adjunto (Opcional)
                                </legend>
                                <div className="politica-upload-wrapper">
                                    <div className="politica-upload-actions">
                                        <input
                                            type="file"
                                            id="politica-file-new"
                                            accept="image/*"
                                            onChange={handleImagenChange}
                                            style={{ display: 'none' }}
                                        />
                                        <label htmlFor="politica-file-new" className="politica-upload-btn">
                                            <FontAwesomeIcon icon={faUpload} /> Seleccionar Imagen
                                        </label>
                                        <span className="politica-upload-hint">
                                            {imagen ? imagen.name : 'Formato JPG, PNG, WEBP. Se mostrará encima del título.'}
                                        </span>
                                    </div>
                                    {imagenPreview && (
                                        <div className="politica-preview-container">
                                            <img src={imagenPreview} alt="Vista previa" className="politica-preview-img" />
                                            <button
                                                type="button"
                                                onClick={handleQuitarImagen}
                                                className="politica-remove-img-btn"
                                                title="Quitar imagen"
                                            >
                                                <FontAwesomeIcon icon={faTrash} /> Quitar
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </fieldset>

                            <fieldset>
                                <legend>Contenido / Descripción de la Política *</legend>
                                <textarea
                                    className="politica-textarea"
                                    rows="6"
                                    placeholder="Escribe el texto detallado de la política aquí..."
                                    value={descripcion}
                                    onChange={(e) => setDescripcion(e.target.value)}
                                    required
                                />
                            </fieldset>

                            {cargando ? (
                                <button type="button" className="btnLoading" disabled>
                                    Guardando política...
                                </button>
                            ) : (
                                <button type="submit" className="btnPost">
                                    Guardar Política
                                </button>
                            )}
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}
